"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const master_service_1 = require("./master.service");
const master_controller_1 = require("./master.controller");
const master_repository_1 = require("./master.repository");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entities_1 = require("../../../../service-lib/src/lib/entities");
let MasterModule = class MasterModule {
};
exports.MasterModule = MasterModule;
exports.MasterModule = MasterModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([entities_1.LookUp]), jwt_1.JwtModule],
        providers: [master_service_1.MasterService, master_repository_1.MasterRepository, auth_guard_1.AuthGuard, role_guard_1.RolesGuard],
        controllers: [master_controller_1.MasterController],
    })
], MasterModule);
